import { useQuery } from '@apollo/client';
import { useMemo } from 'react';

import { graphql } from '@eluve/graphql.tada';

const getTenantEnabledBundlesQuery = graphql(`
  query getTenantEnabledBundles($tenantId: uuid!) {
    tenantTemplateBundles(
      where: {
        tenantId: { _eq: $tenantId }
        isEnabled: { _eq: true }
        llm_model_prompt_template: { isBundle: { _eq: true } }
      }
      orderBy: { createdAt: ASC }
    ) {
      tenantId
      llmModelPromptTemplateId
      llm_model_prompt_template {
        id
        displayName
        promptTemplateId
        outputTemplateId
      }
    }
  }
`);

export type TenantBundle = {
  id: string;
  displayName: string;
  promptTemplateId: string;
  outputTemplateId: string | null;
};

export const useTenantBundles = (tenantId: string | null | undefined) => {
  const { data, loading } = useQuery(getTenantEnabledBundlesQuery, {
    variables: { tenantId: tenantId! },
    skip: !tenantId,
  });

  const bundles: TenantBundle[] = useMemo(
    () =>
      (data?.tenantTemplateBundles ?? []).flatMap((ttb) => {
        const bundle = ttb.llm_model_prompt_template;
        if (!bundle) return [];
        return [
          {
            id: bundle.id,
            displayName: bundle.displayName ?? '',
            promptTemplateId: bundle.promptTemplateId,
            outputTemplateId: bundle.outputTemplateId ?? null,
          },
        ];
      }),
    [data],
  );

  return { bundles, loading };
};
